import { render, staticRenderFns } from "./memberStatistics.vue?vue&type=template&id=54722c84&scoped=true"
import script from "./memberStatistics.vue?vue&type=script&lang=js"
export * from "./memberStatistics.vue?vue&type=script&lang=js"
import style0 from "./memberStatistics.vue?vue&type=style&index=0&id=54722c84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54722c84",
  null
  
)

export default component.exports